
export const loading = {
  computed: {
      loading () {
          return this.$apollo.loading;
      }
  },
  watch: {
      loading (value) {
          this.$root.$emit('loading', value);
      }
  }
};
